import React from 'react'
import { Icon, Tooltip, Input, Text, Dropdown, User } from '@components/UI'

const FILE_TYPES = [
  { value: '', children: 'All' },
  { value: 'SKETCH', children: 'Sketches' },
  { value: 'NOTE', children: 'Notes' },
  { value: 'PDF', children: 'PDF Files' },
  { value: 'IMAGES', children: 'Images' },
  { value: 'VIDEOS', children: 'Videos' },
  { value: 'AUDIOS', children: 'Audios' }
]

const Filter = ({ contacts, onChange, value: { participants, type } }) => {
  contacts = contacts.reduce(
    (acc, v) => ({
      ...acc,
      ...v.participants // TODO: array
    }),
    {}
  )

  contacts = Object.keys(contacts).reduce(
    (acc, key) => [...acc, { id: key, ...contacts[key] }],
    []
  )

  return (
    <div className='control-container dark'>
      <button>
        <Icon name='filter' />
      </button>
      <Tooltip
        style={{ width: '220px' }}
        group='c7'
        className='theme color-f background-a border'
        content={
          <div className='tooltip-content'>
            <div className='people-container'>
              <Text
                className='text-d'
                style={{ color: 'rgba(255, 255, 255, .35)' }}
              >
                Shared with
              </Text>
              <div
                style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  maxHeight: 40 * 3.5,
                  overflowY: 'auto'
                }}
              >
                {contacts.map((v) => (
                  <div
                    className='person-container'
                    key={v.id}
                    onClick={() =>
                      onChange(
                        'participants',
                        participants.includes(v.id)
                          ? participants.filter((p) => p !== v.id)
                          : [...participants, v.id]
                      )
                    }
                  >
                    <User
                      img={v.image}
                      name={v.firstname + ' ' + v.lastname}
                      type={v.type}
                      hideName
                      className={`${
                        !participants.length || participants.includes(v.id)
                          ? 'active'
                          : ''
                      }`}
                    />
                    <Tooltip
                      group='c2'
                      className='theme color-f background-a border'
                      content={
                        <Text className='text-d'>
                          {v.firstname} {v.lastname.charAt(0)}.
                        </Text>
                      }
                    />
                  </div>
                ))}
              </div>
            </div>
            <div className='file-type-container'>
              <Text
                className='text-d'
                style={{ color: 'rgba(255, 255, 255, .35)' }}
              >
                File type
              </Text>
              <Dropdown
                dark
                data={FILE_TYPES}
                position='right top'
                action='focus'
                listProps={{
                  style: {
                    width: '100%'
                  }
                }}
                listItem={Text}
                listItemProps={{
                  icon: '',
                  size: 'small'
                }}
                onchoose={({ value }) => onChange('type', value)}
              >
                <Input
                  readOnly
                  value={FILE_TYPES.filter((v) => v.value === type)[0].children}
                  inputClassName={'box-a3 theme theme-a'}
                  icon='arrow angle down'
                  iconProps={{
                    className: 'msg-icon color color-f',
                    style: {
                      marginTop: -21,
                      fontSize: 10,
                      width: 10,
                      opacity: 0.35
                    }
                  }}
                />
              </Dropdown>
            </div>
          </div>
        }
      />
    </div>
  )
}

export default Filter
